/**
 * store 公共
 */

import Vuex from 'vuex';
import { AREA_CODE, AREA_CODE_RULE } from '@/config/enums';
import commonApi from '@/service/common/index';
import baseCreateStore from '@/store/base/create-store';
const { state, actions, mutations } = baseCreateStore(commonApi);
/**
 * 模块-store 
 */
import leadsStore from './leads';
import driverStore from './driver';
import atDriverStore from './at-driver';
import marketingStore from './marketing';
import guideStore from './guide';
import reportStore from './report';
// acc手机验证
const rules = {};
// 新车发布改为前端写死
// AREA_CODE.forEach(
//     item => (rules[item.key] = { formatCheck: '', lengthCheck: '' })
// );
AREA_CODE.forEach(item => {
    rules[item.key] = { formatCheck: '', lengthCheck: '' };
    const formatCheck = _.find(AREA_CODE_RULE[item.key], {
        key: 'format_check'
    });
    const lengthCheck = _.find(AREA_CODE_RULE[item.key], {
        key: 'length_check'
    });
    if (formatCheck) {
        rules[item.key]['formatCheck'] = formatCheck.rule;
    }
    if (lengthCheck) {
        rules[item.key]['lengthCheck'] = lengthCheck.rule;
    }
});

const tempState = {
    rulesData: { ...rules }
};

const tempMutations = {
    setRules_mutations(state, data) {
        state.rulesData = data;
    }
};

const tempActions = {
    // account手机号验证
    rules({ commit }, { host }) {
        // const sendParam = country_code => {
        //     return {
        //         ...commonApi.rules,
        //         data: {
        //             country_code,
        //             // key: "format_check"
        //             host
        //         }
        //     };
        // };
        // return Promise.all(
        //     AREA_CODE.map(item => service(sendParam(item.key)))
        // ).then(data => {
        //     data.forEach(item => {
        //         if (item.result_code === 'success') {
        //             const formatCheck = _.find(item.data, {
        //                 key: 'format_check'
        //             });
        //             const lengthCheck = _.find(item.data, {
        //                 key: 'length_check'
        //             });
        //             if (formatCheck) {
        //                 rules[formatCheck.country_code]['formatCheck'] =
        //                     formatCheck.rule;
        //             }
        //             if (lengthCheck) {
        //                 rules[lengthCheck.country_code]['lengthCheck'] =
        //                     lengthCheck.rule;
        //             }
        //         }
        //     });
        //     commit('setRules_mutations', rules);
        //     return rules;
        // });
        commit('setRules_mutations', rules);
        return rules;
    }
};

const tempGetters = {
    getConfigCarInfo(state) {
        const configData = state.configCarV2Data;
        return carType => {
            if (carType && configData) {
                return configData[carType.toLowerCase()] || {};
            }
            return {};
        };
    }
};

export function createStore() {
    return new Vuex.Store({
        state: { ...state, ...tempState },
        actions: { ...actions, ...tempActions },
        mutations: { ...mutations, ...tempMutations },
        getters: tempGetters,
        modules: {
            leads: leadsStore,
            driver: driverStore,
            atDriver: atDriverStore,
            marketing: marketingStore,
            guide: guideStore,
            report: reportStore
        }
    });
}



// WEBPACK FOOTER //
// ./src/store/index.js